var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticStyle:{"max-width":"900px"},attrs:{"fluid":""}},[_c('v-sheet',[_c('span',{staticClass:"text-h5 d-block mb-3"},[_vm._v("Vorbestellung bearbeiten")]),_c('v-divider',{staticClass:"mb-3"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }